<script>
import { mapState } from 'vuex';
import AboutSwiper from '../../components/aboutSwiper.vue';
import HomeBanner from '../../components/homeBanner.vue';

export default {
    name: "about",
    data() {
        return {};
    },
    computed: {
        ...mapState(['aboutData']),
    },
    components: {
        AboutSwiper,
        HomeBanner
    },
    mounted() {
        this.$store.dispatch('getAbout');
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="about">
        <!-- banner -->
        <div class="top flex">
            <router-link class="item" v-for="(item, index) in aboutData.banner" :key="index" :to="item.link">
                <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                <div class="name position_center text_shadow">{{ item.name }}</div>
            </router-link>
        </div>
        <div class="top_mobiel only_mobile">
            <HomeBanner :data="aboutData.bannerMobile" type="about"/>
        </div>
        <!-- swipers -->
        <AboutSwiper v-for="(item, index) in aboutData.project" :key="index" :data="item.item" :name="item.name" :desc="item.desc"/>
    </div>
</template>

<style scoped lang="scss">
.top{
    width: 100%;
    height: 7.5rem;
    @media only screen and (max-width: 750px) {
        display: none;
    }
    .item{
        flex: 1;
        position: relative;
        .name{
            font-size: .3rem;
            color: #fff;
        }
    }
}
</style>